import BaseFieldsDrawer from "./BaseFieldsDrawer";
import $ from "jquery";
import makeRpcCall from "../../util/jquery_rpc";
import messageResource from "../../messageResource";
import UserNameFormat from "../../util/UserNameFormat"

export default function InvitationDrawer({
    onDialogContentClick = () => {}
} = {}) {
    this.onDialogContentClick = onDialogContentClick
}

InvitationDrawer.prototype = new BaseFieldsDrawer();


InvitationDrawer.prototype.initFields = function(accountSettings){
    this.$resetPasswordButton = $(this.getElementByIdFunction("resetPasswordLink"))
    this.$resendButton = $(this.getElementByIdFunction("resendInvitation"))
    this.$resetPasswordButton.hide()
    this.$resendButton.hide()
    if(this.isNeedDrawResendButton)
        this.initResendInvitationButton(accountSettings);
    if(this.isNeedDrawResetButton)
        this.initResetPasswordButton(accountSettings);
};

InvitationDrawer.prototype.setNeedDrawResetButton = function(isNeed){
    this.isNeedDrawResetButton = isNeed;
};

InvitationDrawer.prototype.setNeedDrawResendButton = function(isNeed){
    this.isNeedDrawResendButton = isNeed;
};

InvitationDrawer.prototype.initResetPasswordButton = function(accountSettings){

    this.$resetPasswordButton.off();
    var self = this;

    var onOkDialogClick = function()
    {
        self._invitationDialog.showSpinner();

        makeRpcCall( "UserManagementService.resetPassword", [accountSettings.id],
                     function ()
                     {
                         self._invitationDialog.hideSpinner();
                         self._invitationDialog.hideAndRemove();
                         self._populateAndShowSecondConfirmationDialog(
                                 "<span class='secondResetPasswordDialog secondConfirmDialog'>" +
                                    messageResource.getEscapedMessage( "userlist.user_popup.confirmation.reset_password.has_been_sent", [self._formatName(accountSettings)] ) +
                                 "</span>",
                                 self.$resetPasswordButton);
                     },
                     function ( jqXHR, textStatus, errorThrown )
                     {
                         self._invitationDialog.hideSpinner();
                         self._invitationDialog.hideAndRemove();
                         if( errorThrown.exception == 'com.actimind.actitime.administration.NoSuchUserException' ) {
                             alert( messageResource.getMessage( 'userlist.js.error_no_such_user.edit_user' ) );
                             if(self.handlerIfNoSuchUserAfterAjax)
                                 self.handlerIfNoSuchUserAfterAjax();
                             return true;
                         }
                         if(errorThrown.exception == 'com.actimind.common.administration.LastManagerInOtherProductException'){
                             alert(messageResource.getMessage('userlist.js.error_last_admin_in_other_product'));
                             return true;
                         }
                     });
    };

    this.$resetPasswordButton.click(() => {
        this._invitationDialog = this._createConfirmDialog()
        let confirmationText = ''
        if (accountSettings.enabled || accountSettings.enabledInOtherProduct) {
            confirmationText = messageResource.getEscapedMessage(
                "userlist.user_popup.confirmation.reset_password.enabled_user",
                [this._formatName(accountSettings), accountSettings.email]
            )
        } else {
            confirmationText = messageResource.getEscapedMessage(
                "userlist.user_popup.confirmation.reset_password.disabled_user",
                [this._formatName(accountSettings)]
            )
        }

        this._invitationDialog.setWrappedContent(confirmationText)
        this._invitationDialog.show(self.$resetPasswordButton, {offset: "28px 15px"}, onOkDialogClick)
    })

    this.$resetPasswordButton.show();
};

InvitationDrawer.prototype.initResendInvitationButton = function(accountSettings){

    this.$resendButton.off();
    var self = this;

    var onOkDialogClick = function()
    {
        self._invitationDialog.showSpinner();

        makeRpcCall( "UserManagementService.resendInvitation", [accountSettings.id],
                     function ()
                     {
                         self._invitationDialog.hideSpinner();
                         self._invitationDialog.hideAndRemove();
                         self._populateAndShowSecondConfirmationDialog(
                                 "<span class='secondResendInvitationDialog secondConfirmDialog'>" +
                                    messageResource.getEscapedMessage( "userlist.user_popup.confirmation.resend.has_been_sent", [accountSettings.email] ) +
                                 "</span>",
                                 self.$resendButton);
                     },
                     function ( jqXHR, textStatus, errorThrown )
                     {
                         self._invitationDialog.hideSpinner();
                         self._invitationDialog.hideAndRemove();
                         if( errorThrown.exception == 'com.actimind.actitime.administration.NoSuchUserException' )
                         {
                             alert( messageResource.getMessage( 'userlist.js.error_no_such_user.edit_user' ) );
                             if( self.handlerIfNoSuchUserAfterAjax )
                                 self.handlerIfNoSuchUserAfterAjax();
                             return true;
                         }
                     } );
    };

    var onResendButtonClick = function()
    {
        self._invitationDialog = self._createConfirmDialog();
        self._invitationDialog.setWrappedContent( messageResource.getEscapedMessage( "userlist.user_popup.confirmation.resend", 
                                                                                     [ self._formatName(accountSettings), accountSettings.email ] ) );
        self._invitationDialog.show(self.$resendButton, {offset: "28px 15px"}, onOkDialogClick)
    };

    const resendInvitationEnabled = accountSettings.enabled || accountSettings.enabledInOtherProduct
    this.$resendButton.on("mousedown", resendInvitationEnabled ? onResendButtonClick : () => {})
    this.$resendButton.show()
    this.$resendButton.toggleClass('disabled', !resendInvitationEnabled)
    if (resendInvitationEnabled) {
        this.$resendButton.removeAttr('title')
    } else {
        this.$resendButton.attr('title', messageResource.getEscapedMessage('userlist.user_popup.disabled_resend_invitation_tooltip'))
    }
};

InvitationDrawer.prototype._formatName = function(accountSettings) {
    return UserNameFormat.formatFML(accountSettings.firstName, accountSettings.lastName, accountSettings.middleInitial);
};

InvitationDrawer.prototype._createConfirmDialog = function() {
    return new InvitationDialog({
        onContentClick: this.onDialogContentClick
    }).init( $(this.lightBoxEl) );
};

InvitationDrawer.prototype._populateAndShowSecondConfirmationDialog = function( content, elementShowAt ) {
    var timerId = null;
    var secondInvitationDialog = this._createConfirmDialog();
    
    timerId = setTimeout( function()
                          {
                              if ( timerId == null )
                                  return;
                              secondInvitationDialog.hideAndRemove();
                          }, 5000 );

    secondInvitationDialog.setWrappedContent( content );
    var secondInvitationDialogWrapper = secondInvitationDialog.getWrapperElement();
    secondInvitationDialogWrapper.addClass( "onlyCloseButton" );
    var lastButton = secondInvitationDialogWrapper.find( ".ui-dialog-buttonset button" ).filter( ":last-child" );
    lastButton.find( "span" ).text( "Close" );
    lastButton.addClass( "shown" );
    secondInvitationDialogWrapper.find( ".invitationDialog" ).css( "height", "40px" );

    secondInvitationDialog.show( elementShowAt, { offset: "28px 15px" }, null, function() { timerId = null; } );
};





// WEBPACK FOOTER //
// ./web/js/administration/userManagement/InvitationDrawer.js